<template>
  <div
    class="tab-content"
  >
    <div class="row tab-pane fade show active">
      <div
        class="col-12 offset-sm-1 col-sm-10 card o-hidden border-0 shadow-lg my-5"
      >
        <div class="card-body p-0">
          <div class="row p-4">
            <div class="container">
              <div class="row my-3" v-if="formStepId !== 0 && stepBefore">
                <a @click="stepForm--" class="text-gray-500">
                  <i class="fas fa-angle-left"></i> ส่วนที่ {{ formStepId }} {{ stepBefore.title }}</a>
              </div>
              <div class="row mt-4">
                <template v-if="formStepId >= 0 && step.title !== ''">
                  <div class="col-12" :class="isBackend ? 'd-flex justify-content-between' : ''">
                    <div v-if="stepForm === 3">
                      <h5 class="text-center mb-5">"โปรดตรวจสอบข้อมูล และกดปุ่ม "ลงทะเบียน" ด้านล่าง"</h5>
                    </div>
                    <h2 class="text-engineer ">
                      <template v-if="!isBackend">ส่วนที่ {{ formStepId + 1 }}</template>
                      {{ step.title }}
                      <template v-if="step.subtitle !== ``">{{
                        step.subtitle
                        }}
                      </template>
                    </h2>
                    <button v-if="isBackend" :disabled="!isApproved" @click="$attrs.editFunction()"
                            class="d-none d-sm-inline-block btn btn-sm px-3"
                            :class="editStatus === `editing` ?  `btn-success` : `btn-engineer`"
                            style="border-radius: 50px;">
                      <template v-if="editStatus === `editing`">
                        <i class="fas fa-download text-white-50"></i> บันทึกข้อมูล
                      </template>
                      <template v-else>
                        <i class="fas fa-edit text-white-50"></i> แก้ไขข้อมูล
                      </template>
                    </button>
                  </div>
                </template>
                <template v-if="formHeader">
                  <div class="col-12">
                    <h2 class="text-engineer ">{{formHeader}}</h2>
                  </div>
                </template>
              </div>
              <div class="row my-4 ">
                <form class="col-12 user">
                  <slot></slot>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "registerForm",
        props: {
          formStepId: Number,
          stepForm: Number,
          step: Object,
          stepBefore: Object,
          realStep: Number,
          formHeader: String,
          isBackend: Boolean,
          isApproved: Boolean,
          editStatus: String
        }
    }
</script>

<style scoped>

</style>